import { DataModules, IDataState } from "@/store/modules/data/index";
import { ActionTree, GetterTree } from "vuex";
import { Methods } from "@/models/methods";
import { IState } from "@/store";
import { ApiPathGetter } from "@/models/api";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (): ApiPathGetter => leadId => {
    const admin = `api/admin/leads/${leadId}/notes`;
    return { admin };
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: `${getters.apiPath(payload.leadId).admin}`,
        storeModule: DataModules.LEADS_NOTES,
        params: {
          with_staged_imports: 1,
          ...payload.params
        }
      },
      { root: true }
    );
  },
  create: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/create",
      {
        ...payload,
        path: `${getters.apiPath(payload.leadId).admin}`,
        storeModule: DataModules.LEADS_NOTES
      },
      { root: true }
    );
  },
  update: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/callApi",
      {
        ...payload,
        method: Methods.PUT,
        path: `${getters.apiPath(payload.leadId).admin}/${payload.id}`,
        storeModule: DataModules.LEADS_NOTES,
        requestConfig: { data: payload.data }
      },
      { root: true }
    );
  },
  remove: async ({ dispatch, getters }, payload) => {
    await dispatch(
      "data/remove",
      {
        ...payload,
        keys: [payload.id],
        path: `${getters.apiPath(payload.leadId).admin}/${payload.id}`,
        storeModule: DataModules.LEADS_NOTES
      },
      { root: true }
    );
  },
  openAddEditModal: ({ rootGetters, dispatch }, payload) => {
    if (!rootGetters["user/can"]("update_lead_note")) {
      return;
    }
    return dispatch(
      "ui/open/windowModal",
      {
        config: {
          component: () =>
            import("@/components/app/admin/notes/addEditNoteModal.vue"),
          width: 480,
          ...payload
        }
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
